<template>
  <v-row class="ma-0 tabStyle" :class="{ changeTab: active }">

    <!--신청가능일수-->
    <v-col class="mt-4 mb-8 pa-0"
           v-if="type === 'parLeave' && GET_APPL_CD !== '155'"
    >
      <v-list-item
          class="apply_list elevation-2"
      >
        <v-list-item-content class="apply_list_num pl-4">
          <!-- <v-list-item-title>신청가능일</v-list-item-title> -->
          <v-list-item-title>휴직기간 종료일</v-list-item-title>
          <v-list-item-subtitle>{{ possibleUseDay }}</v-list-item-subtitle>
          <v-list-item-subtitle>일</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content class="apply_list_divider">|</v-list-item-content>
        <v-list-item-content class="apply_list_num pr-4" >
          <!-- <v-list-item-title>기신청일수</v-list-item-title> -->
          <v-list-item-title>잔여일수</v-list-item-title>
          <v-list-item-subtitle>{{ reaminDay }}</v-list-item-subtitle>
          <v-list-item-subtitle>일</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="12" class="text-center" v-else-if="GET_APPL_CD !== '155'"
      >복직예정일 {{ returnYmd }}일</v-col
    >
    <v-col cols="12" v-if="false" class="text-center tabItem">
      <span class="startDay">시작일</span>
      <span class="mx-4 title-line">-</span>
      <span class="endDay">종료일</span>
    </v-col>

    <!-- <v-col cols="6" class="text-center tabItem startDay">시작일</v-col> -->
    <!-- <v-col cols="6" class="text-center tabItem endDay">종료일</v-col> -->
    <v-col cols="12" class="text-center calendar-title" v-else>날짜선택</v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { getReturnYmd, getExtParLeaAppDetMap, getRemainDaysBefore } from '@/api/workStatus';

export default {
  data: () => ({
    returnYmd: '',
    type: '',
    useDay: '',
    reaminDay :'',
    possibleUseDay: 0,
  }),
  props: {
    activeTab: {
      type: String,
    },
  },
  computed: {
    ...mapGetters([
      'GET_APPL_CD',
      'GET_APPL_SEQ',
      'GET_ORG_APPL_SEQ',
      'GET_APPL_TYPE',
      'GET_REF_SDATE',
      'GET_PER_DAY',
    ]),

    active() {
      if (this.activeTab === 'S') {
        return false;
      } else if (this.activeTab === 'E') {
        return true;
      } else {
        return null;
      }
    },
  },

  methods: {
    ...mapMutations('ELA', ['SET_E_YMD']),
  },

  async mounted() {
    this.type = this.GET_APPL_TYPE;

    if (this.type === 'parLeave') {
      let params = {
        searchApplSeq: this.GET_APPL_SEQ,
        searchApplSeq2: this.GET_ORG_APPL_SEQ,
      };

      let response = await getExtParLeaAppDetMap(params);
      if (response.data.data !== null) {
        // console.log('response ::: '+JSON.stringify(response));
          this.SET_E_YMD(response.data.data.orgTmpRestEndPlanYmd);
          const oldDate = new Date(response.data.data.refSdate);
          const newDate = new Date(response.data.data.orgTmpRestEndPlanYmd);
          let diff = Math.abs(newDate.getTime() - oldDate.getTime());
          diff = Math.ceil(diff / (1000 * 60 * 60 * 24));

          this.useDay = diff + 1;

          let params = {
            sYmd: this.GET_REF_SDATE,
          }

          this.possibleUseDay = response.data.data.orgTmpRestEndPlanYmd;

          //response = await getRemainDaysBefore(params);

          this.useDay = response.data.data.usedDaysBefore;
          this.reaminDay = response.data.data.remainDaysBefore + response.data.data.addLimitTerm;
          this.$store.commit('SET_USE_DAY', this.useDay);

          //this.possibleUseDay = response.data.data.remainDaysBefore - this.GET_PER_DAY;
          //this.possibleUseDay = response.data.data.remainDaysBefore;
      }
    } else {
      let params = {};

      let response = await getReturnYmd(params);

      if (response.data.data !== null) {
        this.$store.commit('SET_RETURNYMD', response.data.data.returnYmd);

        this.returnYmd = response.data.data.returnYmd.substring(0, 4) + '-';
        this.returnYmd += response.data.data.returnYmd.substring(4, 6) + '-';
        this.returnYmd += response.data.data.returnYmd.substring(6, 8);
      }
    }
  },
};
</script>

<style>
.tabStyle .tabItem {
  padding: 15px 0px;
  font-size: 1.125rem;
  background-color: #f9fafa;
}
.tabStyle .tabItem .title-line {
  font-weight: bold;
  color: #087ef7;
}
.tabStyle .startDay {
  font-weight: bold;
  color: #087ef7;
}
.tabStyle .endDay {
  font-weight: 400;
  color: #979b9f;
}
.tabStyle.changeTab .startDay {
  font-weight: 400;
  color: #979b9f;
}
.tabStyle.changeTab .endDay {
  font-weight: bold;
  color: #087ef7;
}
</style>
